import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import dashboardReducer from './slices/dashboardSlice';
import analysisReducer from './slices/analysisSlice';
import paymentReducer from './slices/paymentSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    dashboard: dashboardReducer,
    analysis: analysisReducer,
    payment: paymentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['analysis/analyzeAddress/fulfilled', 'analysis/analyzeApn/fulfilled', 'payment/createSubscriptionIntent/fulfilled'],
        ignoredActionPaths: ['payload.timestamp', 'meta.arg'],
        ignoredPaths: ['analysis.currentAnalysis.timestamp'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;